import { useMemo } from "react";
import { useIntl } from "react-intl";

import { HotelImageCarousel } from "@/features/hotels/components/hotel/HotelImageCarousel";
import { HotelName } from "@/features/hotels/components/hotels/HotelName";
import { HotelStars } from "@/features/hotels/components/hotels/HotelStars";
import type { HotelData } from "@/features/hotels/types/types";

type HotelDetailsCardProps = {
  hotel: HotelData;
  onImageTap: () => void;
};

export function HotelDetailsCard({ hotel, onImageTap }: HotelDetailsCardProps) {
  const intl = useIntl();

  const images = useMemo(
    () =>
      hotel.imagesUrls.map((url, idx) => ({
        url,
        alt: `${hotel.name} ${idx + 1}`,
      })),
    [hotel.imagesUrls, hotel.name],
  );

  return (
    <section className="section-card p-0">
      {images.length ? (
        <div className="px-1 pt-1">
          <HotelImageCarousel images={images} onClick={onImageTap} />
        </div>
      ) : null}

      <div className="p-4">
        <div className="mb-4 text-lg font-semibold">
          <HotelName name={hotel.name} />
        </div>
        <div className="flex items-center gap-2">
          {hotel?.stars > 0 && (
            <HotelStars showLabel={false} stars={hotel.stars} />
          )}
          {hotel.recommended && (
            <span className="rounded bg-surface-accent-softer px-1.5 py-1 text-sm font-semibold text-core-accent-700">
              {intl.formatMessage({
                defaultMessage: "Rahal's Choice",
                description: "Rahal's Choice badge label",
              })}
            </span>
          )}
        </div>
      </div>
      {/* TODO: common facilities section */}
    </section>
  );
}
